import styled from "styled-components";

interface ModalProps {
  $height?: string;
  $maxHeight?: string;
}

export const StyledModal = styled.div<ModalProps>`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--modal-background);
  /* cursor: pointer; */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;

  & > .container {
    width: 56rem;
    height: ${({ $height }) => `calc(${$height} - 3.2rem)`};
    max-height: ${({ $maxHeight }) => `calc(${$maxHeight} - 3.2rem)`};
    background-color: var(--bg-gray-normal);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
    border-radius: 0.8rem;
    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;

    & > .header-wrap {
      width: auto;
      padding: 0.4rem 0.4rem 0.4rem 1.6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 0.1rem solid var(--bg-gray-1);
      width: calc(100% - 2rem);
      height: 4rem;
      .title {
        font: var(--label-medium-400);
        color: var(--text-gray-strong);
      }
      .close-btn {
        box-sizing: content-box;
        border: none;
        padding: 0.4rem;
        background-color: transparent;
        width: 2.4rem;
        height: 2.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        & > svg {
          width: 2.4rem;
          height: 2.4rem;

          path {
            stroke: var(--text-gray-strong);
          }
        }
      }
    }
    & > .body-wrap {
      width: calc(100% - 3.2rem);
      height: 100%;
      padding: 1.6rem;
      display: flex;
      flex-flow: column nowrap;
      gap: 0.8rem;
      overflow-y: auto;
    }

    & > .footer-wrap {
      width: calc(100% - 3.2rem);
      padding: 1.6rem;
      display: flex;
      justify-content: flex-end;
      gap: 0.8rem;
      margin-top: auto;
      &.shadow {
        box-shadow: var(--modal-footer);
      }
    }
  }
`;
